import { render } from "./EditLeaveType.vue?vue&type=template&id=10a4c0fa&scoped=true"
import script from "./EditLeaveType.vue?vue&type=script&lang=js"
export * from "./EditLeaveType.vue?vue&type=script&lang=js"

import "./leave-type.scss?vue&type=style&index=0&id=10a4c0fa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a4c0fa"]])

export default __exports__